<div class="inner-content">
  <ion-card>
      <ion-textarea rows=6  placeholder="Enter a comment here" [(ngModel)]="photoDTO.comment"></ion-textarea>
  </ion-card>

  <ion-fab vertical="top" horizontal="end" slot="fixed">
      <ion-fab-button (click)="modalController.dismiss()" color="danger" size="small">
          <ion-icon name="close"></ion-icon>
      </ion-fab-button>
  </ion-fab>
</div>
